<template>
  <div class="portalAccount">
    <div class="account-section">
      <h3 class="section-title">{{currentLanguage.userdetail}}</h3>
      <el-form :model="ruleForm" ref="ruleForm" :rules="rulesForm" label-width="100px">
        <el-form-item :label="currentLanguage.username" prop="countName">
          <el-input v-model.trim="ruleForm.countName" disabled></el-input>
        </el-form-item>
        <el-form-item :label="currentLanguage.name" prop="userName">
          <el-input v-model.trim="ruleForm.userName" :placeholder="isEditName ? '' : currentLanguage.unset" :disabled="!isEditName" maxlength="32"></el-input>
          <el-button v-show="!isEditName && !founderId && !ruleForm.fromFed" class="resetPassBtn" @click="isEditName=true">{{currentLanguage.edit}}</el-button>
          <el-button v-show="isEditName && !founderId && !ruleForm.fromFed" type="primary" @click="saveName(true)">{{currentLanguage.save}}</el-button>
          <el-button v-show="isEditName && !founderId && !ruleForm.fromFed" @click="saveName(false)">{{currentLanguage.cancle}}</el-button>
        </el-form-item>
      </el-form>
    </div>
    <div class="account-section">
      <h3 class="section-title">{{currentLanguage.accountself}}</h3>
      <el-form :model="ruleForm" ref="ruleForm1" label-width="100px">
        <el-form-item :label="currentLanguage.password" prop="password">
          <el-input
            type="password"
            v-model.trim="ruleForm.password"
            disabled
          ></el-input>
          <el-button class="resetPassBtn" @click="handleResetPassword">{{currentLanguage.rewritePassword}}</el-button>
          <!-- <el-button class="resetPassBtn" disabled  @click="handleResetPassword" type="text">修改密码</el-button> -->
        </el-form-item>
        <el-form-item :label="currentLanguage.phone" prop="phone">
          <el-input v-model.trim="ruleForm.phone" disabled :placeholder="currentLanguage.unbind"></el-input>
          <el-button class="resetPassBtn" v-show="!founderId && !ruleForm.fromFed" @click="handleChangeInfo('0')">{{ruleForm.phone ? currentLanguage.change : currentLanguage.link}}</el-button>
        </el-form-item>
        <el-form-item :label="currentLanguage.email" prop="email">
          <el-input v-model.trim="ruleForm.email" disabled :placeholder="currentLanguage.unbind"></el-input>
          <el-button class="resetPassBtn" v-show="!founderId && !ruleForm.fromFed" @click="handleChangeInfo('1')">{{ruleForm.email ? currentLanguage.change : currentLanguage.link}}</el-button>
        </el-form-item>
        <el-form-item v-if="ruleForm.wxState" label="." prop="wechat_open">
          <img :src="require(`@/assets/images/wechaticon.png`)" alt="">
          <el-input v-model.trim="ruleForm.wechat_open" :placeholder="currentLanguage.unbind" disabled></el-input>
          <el-button class="resetPassBtn" v-show="!founderId && !ruleForm.fromFed" @click="handleChangeInfo('2')">{{ruleForm.wechat_open ? currentLanguage.bindnone : currentLanguage.bind}}</el-button>
        </el-form-item>
        <el-form-item v-if="ruleForm.orcidState" label="." prop="orcid">
          <img :src="require(`@/assets/images/orcidicon.png`)" alt="">
          <el-input v-model.trim="ruleForm.orcid" :placeholder="currentLanguage.unbind" disabled></el-input>
          <el-button class="resetPassBtn" v-show="!founderId && !ruleForm.fromFed" @click="handleChangeInfo('3')">{{ruleForm.orcid ? currentLanguage.bindnone : currentLanguage.bind}}</el-button>
        </el-form-item>
        <el-form-item v-if="ruleForm.weiboState" label="." prop="weibo">
          <img :src="require(`@/assets/images/weiboicon.png`)" alt="">
          <el-input v-model.trim="ruleForm.weibo" :placeholder="currentLanguage.unbind" disabled></el-input>
          <el-button class="resetPassBtn" v-show="!founderId && !ruleForm.fromFed" @click="handleChangeInfo('4')">{{ruleForm.weibo ? currentLanguage.bindnone : currentLanguage.bind}}</el-button>
        </el-form-item>
        <el-form-item v-if="ruleForm.dtState" label="." prop="ding_talk">
          <img :src="require(`@/assets/images/dingtalkicon.png`)" alt="">
          <el-input v-model.trim="ruleForm.ding_talk" :placeholder="currentLanguage.unbind" disabled></el-input>
          <el-button class="resetPassBtn" v-show="!founderId && !ruleForm.fromFed" @click="handleChangeInfo('5')">{{ruleForm.ding_talk ? currentLanguage.bindnone : currentLanguage.bind}}</el-button>
        </el-form-item>
        <!-- <el-form-item label="启用状态" prop="enable">
          <el-switch v-model="ruleForm.enable" disabled></el-switch>
        </el-form-item> -->
      </el-form>
    </div>
    <el-dialog
      :title="currentLanguage.changepassword"
      width="600px"
      :visible.sync="dialogPasswordVisible"
    >
      <el-form
        :model="ruleFormPassword"
        :rules="rulesPassword"
        ref="ruleFormPassword"
        label-width="100px"
      >
        <el-form-item :label="currentLanguage.oldpassword" prop="oldPassword">
          <el-input
            name="oldPassword"
            type="password"
            v-model.trim="ruleFormPassword.oldPassword"
            :placeholder="currentLanguage.oldpasswordP"
          ></el-input>
        </el-form-item>
        <el-form-item :label="currentLanguage.newpassword" prop="newPassword">
          <el-input
            name="newPassword"
            type="password"
            v-model.trim="ruleFormPassword.newPassword"
            :placeholder="currentLanguage.newpasswordP"
          ></el-input>
        </el-form-item>
        <el-form-item :label="currentLanguage.conpassword" prop="sureNewPassword">
          <el-input
            name="sureNewPassword"
            type="password"
            v-model.trim="ruleFormPassword.sureNewPassword"
            :placeholder="currentLanguage.conpasswordP"
          ></el-input>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitPasswordForm">{{currentLanguage.submit}}</el-button>
        <el-button @click="dialogPasswordVisible = false">{{currentLanguage.cancle}}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title="sendType === '0' ? currentLanguage.bindphone : sendType === '1' ? currentLanguage.changephone : sendType === '2' ? currentLanguage.bindemail : currentLanguage.changeemail"
      width="600px"
      :visible.sync="dialogChangeVisible"
      @close="initFormNewInfo"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <el-form
        :model="formNewInfo"
        :rules="ruleformNewInfo"
        ref="formNewInfo"
        label-width="100px"
      >
        <el-form-item v-if="sendType === '0' || sendType === '1'" :label="currentLanguage.dphone" prop="phone">
          <el-input
            v-model.trim="formNewInfo.phone"
            maxlength="11"
            :placeholder="currentLanguage.phonePlace"
          ></el-input>
        </el-form-item>
        <el-form-item v-if="sendType === '2' || sendType === '3'" :label="currentLanguage.demail" prop="email">
          <el-input
            v-model.trim="formNewInfo.email"
            :placeholder="currentLanguage.emailPlace"
          ></el-input>
        </el-form-item>
        <el-form-item :label="currentLanguage.code" prop="code">
          <el-input
            v-model.trim="formNewInfo.code"
            :maxlength="6"
            :placeholder="currentLanguage.codePlace"
          ></el-input>
          <el-button type="primary" class="send-code" :disabled="clicked" @click="sendCode">{{clicked ? time + currentLanguage.timeTips : currentLanguage.send}}</el-button>
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAddForm">{{currentLanguage.submit}}</el-button>
        <el-button @click="dialogChangeVisible = false">{{currentLanguage.cancle}}</el-button>
      </div>
    </el-dialog>
    <el-dialog
      :title=" providerId === 'wechat_open'? currentLanguage.wechat : providerId === 'weibo' ? currentLanguage.weibo : providerId === 'ding_talk' ? currentLanguage.ding_talk_login : currentLanguage.orcidlogin"
      width="600px"
      :visible.sync="dialogBindVisible"
      @close="initIframe"
      :close-on-click-modal="false"
      :close-on-press-escape="false"
    >
      <iframe :src="src" width = 500 height = 300 alt="" ></iframe>
      <!-- <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="submitAddForm">确 定</el-button>
        <el-button @click="dialogChangeVisible = false">取 消</el-button>
      </div> -->
    </el-dialog>
    <el-dialog :title="currentLanguage.unlink" width="500px" :visible.sync="dialogRemove">
      <div class="deleteText">{{currentLanguage.unlinktips}} {{providerId === 'wechat_open'? currentLanguage.wcscan : providerId === 'weibo' ? currentLanguage.wbcan : (providerId === 'ding_talk' ? currentLanguage.ding_talk : currentLanguage.orcid)}} {{currentLanguage.login}}</div>
      <div slot="footer" class="dialog-footer">
        <el-button type="primary" @click="deleteProvid">{{currentLanguage.submit}}</el-button>
        <el-button @click="dialogRemove = false">{{currentLanguage.cancle}}</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import APIS from "@/apis/userManage.js"
import language from "@/assets/messages/language"
import { Message } from "element-ui"
import md5 from 'js-md5'
const phoneExg = /^((13|14|15|17|18|19)[0-9]{1}\d{8})$/
const emailExg = /^[a-zA-Z0-9_.-]+@[a-zA-Z0-9-]+(\.[a-zA-Z0-9-]+)*\.[a-zA-Z0-9]{2,6}$/
let currentLanguage = {}
export default {
  data() {
    // 检验新密码
    // var checkFormOldPassword = (rule, value, callback) => {
    //   // 至少8位，需包含大小写字母和数字
    //   let pattern = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,}$/g
    //   if (value === '') {
    //     callback(new Error('请输入原密码'));
    //   } else if (!pattern.test(value)) {
    //     callback(new Error('至少8位，需包含大小写字母和数字'));
    //   } else {
    //     callback();
    //   }
    // }
    // 校验手机号
    const checkPhone =  (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      if (value === "") {
        callback(new Error(currentLanguage.inputtips1))
      } else if (!phoneExg.test(value)) {
        callback(new Error(currentLanguage.inputtips2))
      } else {
        callback()
      }
    }
    // 校验邮箱
    const checkEmail =  (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      if (value === "") {
        callback(new Error(currentLanguage.inputtips3))
      } else if (!emailExg.test(value.trim())) {
        callback(new Error(currentLanguage.inputtips4))
      } else {
        callback()
      }
    }
    // 检验新密码
    var checkFormNewPassword = (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      let pattern = /^(?=.*[0-9].*)(?=.*[A-Z].*)(?=.*[a-z].*).{8,}$/g
      if (value === "") {
        callback(new Error(currentLanguage.inputtips5))
      } else if (!pattern.test(value)) {
        callback(new Error(currentLanguage.inputtips6))
      } else {
        callback()
      }
    }
    // 检验确认密码
    var checkFormSurePassword = (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      if (value === "") {
        callback(new Error(currentLanguage.inputtips7))
      } else if (value !== this.ruleFormPassword.newPassword) {
        callback(new Error(currentLanguage.inputtips8))
      } else {
        callback()
      }
    }
    // 检验确认密码
    var checkUserName = (rule, value, callback) => {
      // 至少8位，需包含大小写字母和数字
      if (value.trim() === "") {
        callback(new Error(currentLanguage.inputtips9))
      } else {
        callback()
      }
    }
    return {
      breadcrumb: [
        {
          label: ''
        }
      ],
      founderId: false,
      ruleForm: {
        countName: "",
        userName: "",
        phone: "",
        email: "",
        enable: true,
        password: "ffounder123",
        wechat_open: '',
        orcid: '',
        weibo: '',
        ding_talk: '',
        fromFed: false,
        wxState: false,
        orcidState: false,
        weiboState: false,
        dtState: false
      },
      realmName: this.$realm,
      userName: "",
      dialogPasswordVisible: false,
      ruleFormPassword: {
        oldPassword: "",
        newPassword: "",
        sureNewPassword: ""
      },
      rulesPassword: {
        oldPassword: [
          { required: true, message: currentLanguage.inputtips10, trigger: "blur" }
        ],
        newPassword: [
          { required: true, validator: checkFormNewPassword, trigger: "blur" }
        ],
        sureNewPassword: [
          { required: true, validator: checkFormSurePassword, trigger: "blur" }
        ]
      },
      oldForm:{},//原始用户信息
      isEditName: false,
      dialogChangeVisible: false,
      time: 60,
      timer: null,
      formNewInfo: {
        phone: '',
        email: '',
        code: ''
      },
      clicked: false,
      sendType: "0",
      ruleformNewInfo: {
        phone: [
          { required: true, validator: checkPhone, trigger: "blur" }
        ],
        email: [
          { required: true, validator: checkEmail, trigger: "blur" }
        ],
        code: [
          { required: true, message: currentLanguage.inputtips11, trigger: "blur" }
        ]
      },
      rulesForm: {
        userName: [
          { required: false, validator: checkUserName, trigger: "blur" }
        ],
      },
      dialogBindVisible: false,
      providerId: '',
      dialogRemove: false,
      src: ''
    }
  },
  computed: {
    // 404页面不展示导航菜单
    currentLanguage() {
      currentLanguage = language.languageJson[this.$store.state.currentLanguage]
      return currentLanguage
    }
  },
  watch: {
    // 监听currentModel变化，确保模式切换时breadcrumb能更新
    '$store.state.currentModel'() {
      this.updateBreadcrumb()
    },
    // 监听语言变化，更新breadcrumb
    '$store.state.currentLanguage'() {
      this.updateBreadcrumb()
    },
    // 监听currentLanguage computed变化，更新breadcrumb
    currentLanguage: {
      handler() {
        this.updateBreadcrumb()
      },
      immediate: true
    }
  },
  created() {
    this.founderId = location.href.indexOf('founderid') > -1 ? true : false;
    try {
      this.userName = this.$keycloak.tokenParsed.preferred_username
    } catch (error) {
      console.log(error)
    }
    // 确保breadcrumb在created时更新
    this.updateBreadcrumb()
  },
  mounted() {
    if (this.userName) {
      this.getRealmsUserInfor()
    }
    let code = this.getQueryString('code'),
      state = this.getQueryString('state')
    if(localStorage.getItem('providerId') && code && state) {
      this.providerId = localStorage.getItem('providerId')
      localStorage.removeItem('providerId')
      let params = {
        code,
        state
      }
      this.bindCallBack(params)
    }
    // 在mounted时再次更新breadcrumb，确保显示正确
    this.$nextTick(() => {
      this.updateBreadcrumb()
    })
  },
  methods: {
    // 更新breadcrumb到store
    updateBreadcrumb() {
      // 更新data中的breadcrumb
      if (this.currentLanguage && this.currentLanguage.pagetitle) {
        this.breadcrumb = [
          {
            label: this.currentLanguage.pagetitle
          }
        ]
        // 更新到store
        this.$store.commit("update_breadcrumb", this.breadcrumb)
      }
    },
    // 获取账户信息详情
    async getRealmsUserInfor() {
      let { status, data } = await APIS.getPortalAccountInfo(
        this.realmName,
        this.userName
      )
      if (status === 0) {
        this.ruleForm.countName = data && data.accountname
        this.ruleForm.userName = data && data.username
        this.ruleForm.phone = (data && data.telephone) || ""
        this.ruleForm.email = data && data.email
        this.ruleForm.enable = data && data.enabled
        this.ruleForm.fromFed = data && data.fromFed
        this.ruleForm.wxState = data && data.wechatOpen
        this.ruleForm.orcidState = data && data.orcid
        this.ruleForm.weiboState = data && data.weibo
        this.ruleForm.dtState = data && data.dingTalk
        this.ruleForm.wechat_open = ''
        this.ruleForm.orcid = ''
        this.ruleForm.weibo = ''
        this.ruleForm.ding_talk = ''
        if(data.federatedIdentities && data.federatedIdentities.length > 0){
          for(let i in data.federatedIdentities){
            if(data.federatedIdentities[i].identityProvider === 'wechat_open'){
              // this.ruleForm.wechat_open = data.federatedIdentities[i].userName
              this.ruleForm.wechat_open = currentLanguage.binded
            }
            if(data.federatedIdentities[i].identityProvider === 'orcid'){
              this.ruleForm.orcid = currentLanguage.binded
            }
            if(data.federatedIdentities[i].identityProvider === 'weibo'){
              this.ruleForm.weibo = currentLanguage.binded
            }
            if(data.federatedIdentities[i].identityProvider === 'ding_talk'){
              this.ruleForm.ding_talk = currentLanguage.binded
            }
          }
        }
        this.oldForm = JSON.parse(JSON.stringify(this.ruleForm))
      }
      this.oldForm = JSON.parse(JSON.stringify(this.ruleForm))
    },
    // 修改密码
    async postResetPassword() {
      let params = {
        type: "password",
        temporary: false,
        value: this.ruleFormPassword.newPassword,
        oldValue: this.ruleFormPassword.oldPassword
      }
      if(location.origin.indexOf('qikan') > -1 || location.origin.indexOf('journal') > -1 ) {
        params.value = md5(this.ruleFormPassword.newPassword)
        params.oldValue = md5(this.ruleFormPassword.oldPassword)
      }
      let { status } = await APIS.putPortalUpdatePassword(
        this.realmName,
        this.userName,
        { data: params }
      )
      if (status === 0) {
        this.dialogPasswordVisible = false
        sessionStorage.removeItem("currentModel")
        this.$store.commit("change_model", "user")
        this.$keycloak.logoutFn()
      }
    },
    // 修改密码
    handleResetPassword() {
      this.dialogPasswordVisible = true
      this.$nextTick(() => {
        this.initPasswordForm()
      })
    },
    initPasswordForm() {
      this.$refs["ruleFormPassword"].resetFields()
      this.ruleFormPassword.oldPassword = ""
      this.ruleFormPassword.newPassword = ""
      this.ruleFormPassword.sureNewPassword = ""
    },
    submitPasswordForm() {
      this.$refs["ruleFormPassword"].validate(valid => {
        if (valid) {
          this.postResetPassword()
        }
      })
    },
    // 修改信息弹窗
    handleChangeInfo(type){
      if(type === '0'){
        this.sendType = this.ruleForm.phone ? "1" : "0"
        this.dialogChangeVisible = true
      }else if(type === '1'){
        this.sendType = this.ruleForm.email ? "3" : "2"
        this.dialogChangeVisible = true
      } else {
        // 解绑微信
        this.providerId = type === '2' ? 'wechat_open' : (this.providerId = type === '4' ? 'weibo' : (this.providerId = type === '5'? 'ding_talk' : 'orcid'))
        this.ruleForm[this.providerId] ? this.dialogRemove = true : this.bindRender()
      }
    },
    getQueryString(param) {
      var reg = new RegExp("(^|&)" + param + "=([^&]*)(&|$)", "i");
      var r = window.location.search.substring(1).match(reg);
      if (r != null) {
        return r[2];
      }
      return null;
    },
    bindRender(){
      localStorage.setItem('providerId', this.providerId)
      let src = `${ location.origin }/idaas/oauth/render/${ this.providerId }?url=${ location.href.split('?')[0] }&realmName=${this.realmName}`
      if(this.providerId === 'orcid' || this.providerId === 'weibo' || this.providerId === 'ding_talk') {
        location.href = src
      } else {
        this.dialogBindVisible = true
        this.src = src
      }
    },
    initIframe(){
      localStorage.removeItem('providerId')
      this.src = ''
    },
    async bindCallBack(params){
      let { status } =  await APIS.bindCallBack(
        this.providerId,
        location.href.split('?')[0],
        this.realmName,
        { data: params }
      )
      if (status === 0) {
        this.getRealmsUserInfor()
        // if(this.providerId === "wechat_open"){
        //   this.bindAccount(data.uuid, data.username)
        // } else {
        //   this.bindAccount(data.uuid)
        // }
      }
    },
    async bindAccount(id, username){
      let params = {
        userId: id,
        userName: this.userName
      }
      if(this.providerId === "wechat_open"){
        params.identityUserName = username
      }
      let { status } = await APIS.bindAccount(
        this.realmName,
        this.providerId,
        { data: params }
      )
      if (status === 0) {
        // location.href = location.href.split('?')[0]
        this.getRealmsUserInfor()
      }
    },
    async deleteProvid(){
      let params = {
        userName: this.userName,
      }
      let { status } = await APIS.deleteProvid(
        this.realmName,
        this.providerId,
        { data: params }
      )
      this.dialogRemove = false
      if (status === 0) {
        this.getRealmsUserInfor()
      }
    },
    initFormNewInfo(){
      this.clearInter()
      this.$refs['formNewInfo'].resetFields()
      this.formNewInfo.phone = null
      this.formNewInfo.email = null
      this.formNewInfo.code = null
    },
    clearInter(){
      clearInterval(this.timer)
      this.timer = null
      this.time = 60
      this.clicked = false
    },
    // 发送验证码
    sendCode(){
      let propName, params = {}, type
      this.sendType === "0" || this.sendType === "1" ? ( type = "send-phone", params.phoneNumber = this.formNewInfo.phone, params.userName = this.userName, propName = 'phone' ) : ( type = "send-email", params.email = this.formNewInfo.email, params.userName = this.userName, propName = 'email' )
      this.$refs['formNewInfo'].validateField(propName, (errorMessage) => {
        if(errorMessage == ''){
          this.sendCodeAjax(params, type)
        }
      });
    },
    async sendCodeAjax(params, type){
      this.getTimeInterval()
      let { status } = await APIS.sendCode(
        this.realmName,
        type,
        { data: params }
      )
      if (status === 0) {
        // 发送验证码成功
        Message.info({
          message: currentLanguage.sendSuccess
        })
      } else {
        this.clearInter()
      }
    },
    //绑定修改手机号/邮箱
    submitAddForm(){
      this.$refs["formNewInfo"].validate(valid => {
        if (valid) {
          this.submitAddFormAjax()
        }
      })
    },
    async submitAddFormAjax(){
      let params = {
        code: this.formNewInfo.code
      }
      let type
      this.sendType === "0" || this.sendType === "1" ? ( type = "update-phone", params.phoneNumber = this.formNewInfo.phone ) : ( type = "update-email", params.email = this.formNewInfo.email.trim() )
      let { status } = await APIS.changeNumber(
        this.realmName,
        this.userName,
        type,
        { data: params }
      )
      if (status === 0) {
        this.dialogChangeVisible = false
        this.getRealmsUserInfor()
      }
    },
    // 修改名称
    async saveName(type){
      if(type){//保存
        if(!this.ruleForm.userName.trim()) {
          return false
        }
        let params = {
          fullName: this.ruleForm.userName.trim()
        }
        let { status } = await APIS.changeUserName(
          this.realmName,
          this.userName,
          { data: params }
        )
        if (status === 0) {
          this.isEditName = false
          this.getRealmsUserInfor()
        } else {
          this.ruleForm.userName = this.oldForm.userName
          this.isEditName = false
        }
      } else {//取消
        this.ruleForm.userName = this.oldForm.userName
        this.isEditName = false
      }
      this.$refs['ruleForm'].clearValidate()
    },
    getTimeInterval(){
      this.clicked = true
      let that = this
      this.timer = setInterval(function(){
        that.time--
        if(that.time<0){
          that.clearInter()
        } else {
          // btnEl.html(time+'s重新发送')
        }
      }, 1000)
    }
  }
}
</script>

<style lang="scss">
.portalAccount {
  .title{
    height: 24px;
    line-height: 24px;
    font-size: 16px;
    color: #333;
  }
  .account-section {
    margin-bottom: 28px;
  }
  .account-section + .account-section {
    border-top: 1px solid #e8e8e8;
    padding-top: 20px;
  }
  .section-title {
    font-size: 16px;
    font-weight: 600;
    color: #333;
    margin: 0 0 16px 0;
    padding-left: 8px;
    border-left: 3px solid #4497ec;
    line-height: 18px;
  }
  .el-form {
    .el-form-item{
      .el-form-item__content{
        display: flex;
        align-items: center;
        justify-content: flex-start;
        margin-left: 0!important;
        flex-direction: row;
        .el-input{
          width: 50%;
          margin-right: 10px;
        }
        img{
          position: absolute;
          left: -40px;
        }
      }
    }
    .resetPassBtn {
      width: 60px;
      font-weight: normal;
      margin-left: 14px;
      margin-top:5px;
      color: #4497ec;
      cursor: pointer;
      text-align:left;
      padding: 0;
      border:0;
      background:#fafafa;
    }
    .resetPassBtn.is-disabled{
      color: #999;
    }
    .resetPassBtn.is-disabled:hover {
      color: #999;
      cursor: not-allowed;
      background-image: none;
      border-color: #ececec;
    }
  }
  .el-dialog {
    &__title {
      color: #333333;
      font-weight: 600;
    }
    &__body {
      // padding: 0 50px;
      .el-input{
        width: auto!important;
        flex-grow: 1;
      }
    }
  }
  .el-tabs {
    &__nav-wrap {
      padding-left: 32px;
    }
  }
  .border-box{
    border: 1px solid rgba(0,0,0,0.125);
    padding: 10px;
    border-radius: 4px;
  }
  .border-box-sec{
    margin-top: 20px;
  }
  .el-switch{
    margin-top: 10px
  }
  .send-code{
    margin-right: 10px;
    width: 120px;
  }
  iframe{
    height: 400px;
  }
}
@media (max-width: 768px) {
  .portalAccount .el-dialog {
    width: 90%!important;
  }
  .portalAccount .el-dialog__body {
    padding-left: 0!important;
    padding-right: 10px!important;
  }
  .portalAccount .el-form {
    width: 100%;
  }
}
</style>
